module.exports = __webpack_public_path__ + "static/media/pilot.9808f3b1.svg";